import './index.scss'

import { forwardRef } from 'react'

// A date picker's trigger, for react-datepicker's `customInput`. A button
// rather than the picker's own text input, so it's exactly as wide as the date
// it shows instead of a fixed box with the date pushed to one side. The picker
// hands it the formatted value and its open handler.
const DateButton = forwardRef<HTMLButtonElement, {
  value?: string;
  onClick?: () => void;
  disabled?: boolean;
}>((props, ref) => {
  return <button
    ref={ref}
    type='button'
    className='date-button'
    disabled={props.disabled}
    onClick={props.onClick}>
    {props.value || 'Choose a date'}
  </button>
});

export default DateButton;
